import { ExpandMore } from '@mui/icons-material';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import { UserAvatar } from '@/tracker/entities/user';
import { useIssueDrawer } from '@/tracker/features/issueDrawer';
import { TaskRef } from '@/tracker/types';

import { LaneOwner } from '../../model/BoardStore';

import s from './LaneHeader.module.scss';

type Props = {
  owner: LaneOwner;
  total: number;
  isCollapsed: boolean;
  onToggle: () => void;
};

/** Заголовок свимлейна на всю ширину доски: кнопка сворачивания, исполнитель или родитель, число задач */
const LaneHeader: React.FC<Props> = ({ owner, total, isCollapsed, onToggle }) => {
  const { issueLink } = useIssueDrawer();

  const renderParent = (parent: TaskRef | null) => {
    if (!parent) return <span className={s.lane__none}>Без родительской задачи</span>;

    return (
      <>
        <Link to={issueLink(parent.key)} className={s.lane__link}>
          {parent.key}
        </Link>
        <span className={s.lane__summary}>{parent.summary}</span>
      </>
    );
  };

  const renderOwner = () => {
    if (owner.type === 'parent') return renderParent(owner.parent);

    if (!owner.user) return <span className={s.lane__none}>Без исполнителя</span>;

    return (
      <>
        <UserAvatar name={owner.user.displayName} size={24} />
        {owner.user.displayName}
      </>
    );
  };

  return (
    <div className={s.lane}>
      {/* Доска скроллится вбок: заголовок прилипает к левому краю */}
      <div className={s.lane__content}>
        <button
          type="button"
          className={cn(s.lane__toggle, isCollapsed && s.lane__toggle_collapsed)}
          aria-expanded={!isCollapsed}
          aria-label={isCollapsed ? 'Развернуть строку' : 'Свернуть строку'}
          onClick={onToggle}
        >
          <ExpandMore fontSize="small" />
        </button>
        {renderOwner()}
        <span className={s.lane__total}>{total}</span>
      </div>
    </div>
  );
};

export { LaneHeader };
